const version = process.env.NODE_ENV == 'development' ? '2022915' : '2022819';
const environment = process.env.NODE_ENV == 'development' ? 'DEV' :'PRO'; //DEV PRO
const host = environment == 'DEV' ? 'https://action.op.dianhun.cn/' : 'https://m3guo.17m3.com/';
const domain = environment == 'DEV' ? 'http://192.168.217.171:9527/' : 'https://www.m3guo.com/activity/202209/card1348bf3/';

const getQueryVariable = function (variable) {
    var query = window.location.search.substring(1) || window.location.hash.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
        return pair[1];
        }
    }
    return '';
}

const wx_share_text = {
  title: '梦三国周年庆集卡', // 分享标题
  desc: '梦三国周年庆集卡开始咯，集齐可领取游戏礼包、火炬手随机点亮卡，还能抽取纪念熊猫周边。', // 分享描述
  imgUrl: 'https://web-resource.17m3.com/m3guo/202209/card/sns.png', // 分享图标   
}

const tipsImg = ['LT16', 'D774', 'KR54', 'LK09', 'LE95', 'LQ57',]

let search_code = getQueryVariable('code') ? ('?code=' + getQueryVariable('code')) : '';
let add = getQueryVariable('code') ? '&' : '?';
let search_key = getQueryVariable('key') ? (add + 'key=' + getQueryVariable('key')) : '';

const actUrl = '202109/card/public/index.php/api/';

const ajax_url_map = {
    login : host + 'common/pool/public/index.php/api/' + 'user/login/login?callback=' + encodeURIComponent(domain) + '&ver=' + version,
    logout : '',
    free : host + 'common/pool/public/index.php/api/' + 'user/login/pocket?ver=' + version,
    mplat : host + 'common/pool/public/index.php/api/' + '/user/login/platform' + '?ver=' + version, //梦平台自登录验证
    userinfo : host + actUrl + 'user/getUserInfo',
    queryplayer : host + actUrl + 'user/getM3gName',
    bind : host + actUrl + 'user/bind',
    share : host + actUrl + 'user/share',
    acceptShare : host + actUrl + 'user/acceptShare',
    request: host + actUrl + 'user/request',
    acceptRequest : host + actUrl + 'user/acceptRequest',
    reward : host + actUrl + 'user/reward',
    address : host + actUrl + 'user/address',
    draw : host + actUrl + 'user/getCard',
    cardInfo : host + actUrl + 'user/getUserCard',
    getShareInfo : host + actUrl + 'user/getShareInfo',
    getRequestInfo : host + actUrl + 'user/getRequestInfo',
    tips : 'https://tool.m3guo.com/api/web/m3goods/eq-item/',//tip获取
}

const bodyScroll = function(event) {
    event.preventDefault();
}

const cleanArray = function (actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

const param =  function (json) {
  if (!json) return ''
  return cleanArray(Object.keys(json).map(key => {
    if (json[key] === undefined)
      return ''
    return encodeURIComponent(key) +
    '=' + encodeURIComponent(json[key])
  })).join('&')
}

const delUrlParam = function(url, key) {
    let baseUrl = url.split('?')[0] + '?';
    let query = url.split('?')[1];
    if(!query)return url;
    if (query.indexOf(key) > -1) {
        let obj = {};
        let arr = query.split('&');
        for (let i = 0; i < arr.length; i++) {
            arr[i] = arr[i].split('=');
            obj[arr[i][0]] = arr[i][1];
        }
        delete obj[key];
        let url =
            baseUrl +
            JSON.stringify(obj)
                .replace(/[\"\{\}]/g, '')
                .replace(/\:/g, '=')
                .replace(/\,/g, '&');
        return url;
    } else {
        return url;
    }
}

const cardInfo = [0,0,0,0,0];

console.log(ajax_url_map.login);

const requestTxt = ["救救我，救救我，可以送我一张「梦」字卡片吗？","好哥哥，好哥哥，可以送我一张「三」字卡片吗？","嘤嘤嘤，可以送我一张「周」字卡片吗？","我就缺这一张卡，谢谢老板，可以送我一张「年」字卡片吗？","祝你欧气中纪念熊猫，可以送我一张「庆」字卡片吗？"];

const applyTxt = ["周年庆口袋集卡抢纪念熊猫啦，赠送你一个「梦」字卡片。","周年庆口袋集卡抢纪念熊猫啦，赠送你一个「三」字卡片。","周年庆口袋集卡抢纪念熊猫啦，赠送你一个「周」字卡片。","周年庆口袋集卡抢纪念熊猫啦，赠送你一个「年」字卡片。","周年庆口袋集卡抢纪念熊猫啦，赠送你一个「庆」字卡片。"];

export default {
    bodyScroll,
    ajax_url_map,
    getQueryVariable,
    domain,
    version,
    param,
    cardInfo,
    delUrlParam,
    requestTxt,
    applyTxt,
    tipsImg,
    wx_share_text,
}



// WEBPACK FOOTER //
// ./src/assets/js/global.js